export const initDialogData = {
  ExpJobOrdId: 0,
  IsCost: 0, 
  JobOrdId: null,
  ExpId: null,
  VatPrct:0,
  WhtPrct: 0,
  UntPr: 0,
  UntPrB4Vat: 0,
  Qty: 1,
  Total: 0,
  IsOwnRcpt:1,
  WhtPayrTyp: null,
  WhtTypId: null,
  SupId: null,
  Rmk: "",
  DocNo: "",
  DocDte: null,
}

export const initJobOrdData = {
  AptTm: "",
  ArvTm: "",
  Bkg: "",
  ContNo: "",
  ContSize:"",
  ContTyp:"",
  ContSizeFull: "",
  Exps: [],
  FinDte: "",
  JobNo: "",
  JobOrdId: "",
  JobSNm: "",
  LevTm: "",
  Rmk:"",
  RtnDteSt:"",
  Loc: "",
  Memo: "",
  RtnPlc: "",
  TakePlc: "",
}